import '@fancyapps/fancybox';
import 'slick-carousel';

class Hero {
	constructor($el) {
		// module vars declarations
		this.$el = $el;
		this.$slider = this.$el.find('.hero__poster > .image-slider.slider > p');
	
		// methods initialization
		this.init();
	}

	init() {
		// slider
		this.slider();
	}

	slider() {
		if (typeof this.$slider === "undefined") {
			return;
		}

		if (this.$slider.find('> img').length <= 1) {
			return;
		}

		this.$slider.slick({
			adaptiveHeight: false,
			autoplay: true,
			fade: true,
			autoplaySpeed: 1000,
			speed: 5000,
			arrows: false,
			dots: false,
			infinite: true,
			mobileFirst: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			pauseOnHover: false,
			pauseOnFocus: false
		});
	}
}

export default Hero;